import React, { useCallback, useEffect, useState } from "react";
import { api } from "../../lib/api";
import { toast } from "sonner";
import { ModeSelector } from "../../components/admin/payment-center/ModeSelector";
import { PilotManager } from "../../components/admin/payment-center/PilotManager";
import { SignaturePanel } from "../../components/admin/payment-center/SignaturePanel";
import { MetricsGrid } from "../../components/admin/payment-center/MetricsGrid";
import { GroupsTable, AuditList, WaiversTable } from "../../components/admin/payment-center/HistoryPanels";
import { ConfirmDialog } from "../../components/admin/payment-center/ConfirmDialog";

export default function PaymentCenterAdmin() {
  const [st, setSt] = useState(null);
  const [groups, setGroups] = useState([]);
  const [audit, setAudit] = useState([]);
  const [failures, setFailures] = useState([]);
  const [waivers, setWaivers] = useState([]);
  const [pending, setPending] = useState(null);
  const [busy, setBusy] = useState(false);

  const load = useCallback(async () => {
    const [s, g, a, f, w] = await Promise.all([api.get("/admin/payment-center/status"), api.get("/admin/payment-center/groups"),
      api.get("/admin/payment-center/audit"), api.get("/admin/payment-center/webhook-failures"), api.get("/admin/payment-center/charge-waivers")]);
    setSt(s.data); setGroups(g.data); setAudit(a.data); setFailures(f.data); setWaivers(w.data);
  }, []);
  useEffect(() => { load().catch(() => toast.error("Falha ao carregar a Central")); }, [load]);

  const apply = async (typed, reason) => {
    setBusy(true);
    try {
      const url = pending.kind === "mode" ? "/admin/payment-center/mode" : "/admin/payment-center/signature-mode";
      await api.post(url, { mode: pending.value, confirm_text: typed, reason });
      toast.success("Configuração atualizada");
      await load();
      return true;
    } catch (e) { toast.error(e?.response?.data?.detail || "Alteração recusada"); return false; }
    finally { setBusy(false); }
  };

  if (!st) return <div className="p-6 text-sm" data-testid="pc-admin-loading">Carregando...</div>;
  const isMode = pending?.kind === "mode";
  return (
    <div data-testid="payment-center-admin-page" className="space-y-6">
      <div className="topbar">
        <div>
          <div className="text-[10px] tracking-[0.2em] uppercase text-[#5C5A57]">Portal da Cliente</div>
          <h1 className="font-display text-4xl font-bold tracking-tight mt-1">Central de Pagamentos</h1>
          <p className="text-sm text-[#5C5A57] mt-2 max-w-2xl">Controle do PIX agrupado. Todas as regras são validadas no servidor. PIX já emitidos continuam sendo conciliados em qualquer modo.</p>
        </div>
      </div>
      <ModeSelector mode={st.mode} readiness={st.readiness} onPick={(v) => setPending({ kind: "mode", value: v })} />
      <PilotManager clients={st.pilot_clients} onChange={(c) => setSt((s) => ({ ...s, pilot_clients: c }))} />
      <SignaturePanel readiness={st.readiness} reload={load} onSigMode={(v) => setPending({ kind: "sig", value: v })} />
      <MetricsGrid metrics={st.metrics} />
      <GroupsTable groups={groups} />
      <WaiversTable items={waivers} />
      <AuditList items={audit} failures={failures} />
      <ConfirmDialog open={!!pending} onClose={() => setPending(null)} busy={busy} withReason={isMode} onConfirm={apply}
        title={isMode ? `Alterar a Central para ${pending?.value}` : `Validação de assinatura: ${pending?.value}`}
        description={isMode ? "A alteração é auditada e revalidada pelo servidor." : "EXIGIR rejeita webhooks sem assinatura válida."}
        confirmText={pending ? (isMode ? st.confirm_texts[pending.value] : pending.value) : ""} />
    </div>
  );
}
